module.exports = __webpack_public_path__ + "static/product-d162a70b97f6c4a143f6614805f37e88.svg";